import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MarketmanagerSharedModule } from '../../shared';
import {
    SalesunitService,
    SalesunitPopupService,
    SalesunitComponent,
    SalesunitDetailComponent,
    SalesunitDialogComponent,
    SalesunitPopupComponent,
    SalesunitDeletePopupComponent,
    SalesunitDeleteDialogComponent,
    salesunitRoute,
    salesunitPopupRoute,
    SalesunitResolvePagingParams,
} from './';

const ENTITY_STATES = [
    ...salesunitRoute,
    ...salesunitPopupRoute,
];

@NgModule({
    imports: [
        MarketmanagerSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        SalesunitComponent,
        SalesunitDetailComponent,
        SalesunitDialogComponent,
        SalesunitDeleteDialogComponent,
        SalesunitPopupComponent,
        SalesunitDeletePopupComponent,
    ],
    entryComponents: [
        SalesunitComponent,
        SalesunitDialogComponent,
        SalesunitPopupComponent,
        SalesunitDeleteDialogComponent,
        SalesunitDeletePopupComponent,
    ],
    providers: [
        SalesunitService,
        SalesunitPopupService,
        SalesunitResolvePagingParams,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MarketmanagerSalesunitModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/salesunit/salesunit.module.ts